import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Button from '../../../../../shared/components/Button';
import UserThumbnail from '../../../../../shared/components/UserThumbnail/UserThumbnail';

const YouTubeSuccess = ({
  onRequestClose,
}) => {
  const { t } = useTranslation();
  const user = useSelector(store => get(store, 'auth.user'));
  const testFlow = useSelector(state => state.config.test);

  return <div>

    <h3 className='mb-4'>
      {t('influencers.pages.campaign.apply_side_pane.youtube_connect.connected_successfully')}
    </h3>

    <Card className='p-3'>
      <Row>
        <Col className="col-auto">
          <UserThumbnail platform='youtube' initials={get(user, 'social.yout.nickname')} />
        </Col>
        <Col className="col-auto">
          <div className='text-underline'>
            {get(user, 'social.yout.nickname')}
          </div>
        </Col>
      </Row>
    </Card>


    <hr className='my-6' />
    <Row className='justify-content-end'>
      <Col className="col-auto">
        <ButtonGroup className="non-adaptable">
          <Button
            variant="primary"
            type="submit"
            onClick={onRequestClose}>
            {t('influencers.common.finish')}
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  </div>;
};

YouTubeSuccess.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};
export default YouTubeSuccess;